module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_drag_3.93b7205b.png";